import React, { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import { Link, redirect, useParams } from "react-router-dom";
import { Footer, Navbar } from "../adminComponents";
import axios from "axios";
import configData from "../config.json";
import {format} from "date-fns";
import { useNavigate } from "react-router-dom";

const PendingMessage=()=>{
    const { branchID } = useParams();
    const [orders,setOrderList]=useState([]);
    const navigate=useNavigate();

    useEffect(() => {
        const getOrderList = async () => {
        const response=await axios.get(configData.SERVER_ADMIN_URL+`/pendingMessage/${branchID}`)
          setOrderList(response.data);
        };
        getOrderList();
    }, []);    

    return(
        <>
        <Navbar/>
        <div className="container my-3 py-3">
        <h1 className="text-center">Pending Message</h1>
            <hr/>
          
            <div className="card text-justify">  
                <div className="card-header"></div>           
                    <div className="card-body">
                    <table className="table table-hover">
                        <thead>
                            <th>Sl.</th>
                            <th>Customer Info</th>
                            <th>Message</th>
                        </thead>
                        <tbody>
                        {
                            orders && orders.length>0 && orders.map((data,index)=> 
                            <tr>
                                <td>{index+1}</td>
                                <td>{data.Name}<br></br>{data.Email}</td>
                                <td>{data.Content}</td>
                            </tr>
                         )
                        }
                        </tbody>
                    </table>
                </div>
            </div>
           
        </div>
        <Footer/>
        </>
    ) 
}

export default PendingMessage;